<template>
  <v-dialog v-model="openModalPayment" width="431" persistent>
    <v-card class="rsu">
      <!-- <div style="display: flex; justify-content: space-between; align-items: center"> -->
      <!-- <div class="headline primary--text mb-6 bold7 fs-24">{{ $t('เพิ่มข้อมูล') }}</div> -->
      <ValidationObserver ref="form">
        <div
          style="
              flex-direction: column;
              background-color: white;
              border-radius: 21px;
              padding: 50px
            "
        >
          <Typography h2 bold center :label="$t('ชำระผ่าน QR CODE')" />
          <br />
          <Typography center :label="$t('กรุณาทำการชำระเงินภายใน')" />
          <Typography center h2 medium :label="$t('11/06/2025')" />
          <div style="display: flex; align-items: end; justify-content: center">
            <img
              :src="dataPayment.qrcodeUrl"
              width="200"
              height="200"
              alt="QR Code"
              ref="qrcodeCanvas"
            />
            <button @click="downloadQRCode">
              <img
                :src="iconDownload"
                style="margin-bottom: 15px"
                width="29"
                height="29"
                alt="iconDownload"
              />
            </button>
          </div>
          <div style="display: flex; align-items: end; justify-content: center">
            <v-btn
              bold
              :style="
                `color: ${$vuetify.theme.primary}; text-transform: capitalize; width: 80%; height: 20px; font-size: 12px; border-radius: 25px;`
              "
              :color="`color: ${$vuetify.theme.primary}`"
              outline
              @click="
                () => {
                  postDownloadSlip(dataPayment.transaction_id)
                }
              "
            >
              Download Bill Payment
            </v-btn>
          </div>

          <div style="display: flex; flex-direction: row">
            <Typography bold :label="$t('รหัสอ้างอิง 1:')" />
            <Typography semibold style="margin-left: 5px" :label="dataPayment.refferalCode1" />
          </div>

          <div style="display: flex; flex-direction: row">
            <Typography bold :label="$t('รหัสอ้างอิง 2:')" />
            <Typography semibold style="margin-left: 5px" :label="dataPayment.refferalCode2" />
          </div>

          <div
            style="
                background-color: #E6F0FB;
                display: flex;
                align-items: center;
                justify-content: right;
                padding-right: 30px;
                height: 50px;
                border-radius: 10px;
                margin-top: 17px;
              "
          >
            <Typography h7 :label="$t('ยอดที่ต้องชำระ')" />
            <div style="color:red; margin-left: 7px; font-size: 10px; font-weight: 400;">฿</div>
            <div style="color:red; margin-left: 7px; font-size: 24px; font-weight: 400;">
              {{ this.bath }}
            </div>
          </div>
          <div>
            <Typography
              semibold
              style="margin-top: 25px; margin-left: 10px"
              label="แนบสลิปการชำระเงิน"
            />
            <ValidationProvider
              :rules="{
                required: true
              }"
              name="แนบสลิปการชำระเงิน"
              v-slot="{ errors }"
            >
              <UploadDocument
                :errors="errors"
                @input="uploadImg"
                :typeFile="',image/*'"
                width="100%"
                v-model="dataPayment.slipfile"
                :showListFile="true"
                removeDisplay
              >
              </UploadDocument>
              <div v-if="errors[0]" style="display: flex; align-items: center;">
                <img
                  :src="iconWarning"
                  alt="Warning"
                  style="width: 17px; height: 17px; margin-right: 5px;"
                />
                <div
                  class="pr-2"
                  style="
                    font-size: 14px;
                    font-weight: 500;
                    color: red !important;
                  "
                >
                  กรุณาแนบสลิปการชำระเงิน
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div
            class="flex-all-center mt-10"
            style="justify-content: space-evenly; margin-top: 25px;"
          >
            <v-btn
              :style="
                `color: ${$vuetify.theme.primary}; text-transform: capitalize; width: 40%; height: 40px; font-size: 16px; border-radius: 25px;`
              "
              outline
              @click="showModalPayment"
              class="rsu customCancelBtn"
              depressed
              color="primary"
            >
              ยกเลิก
            </v-btn>

            <v-btn
              class="btn-summit"
              style="border-radius: 6px;color: #FFFFFF; width: 40%; height: 40px; font-size: 16px; border-radius: 25px;"
              depressed
              @click="postUpdateSlip"
            >
              บันทึก
            </v-btn>
          </div>
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import { store } from '@/store/store'
import QRCode from 'qrcode'
import moment from 'moment'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Typography from '@/components/elements/Typography.vue'
import DatePicker from 'vue2-datepicker'
import { ToggleButton } from 'vue-js-toggle-button'
import Button from '@/components/elements/Button.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import UploadDocument from '../AddMemberForm/UploadDocument.vue'

export default {
  components: {
    DatepickerCustomDialog,
    Typography,
    DatePicker,
    Button,
    ToggleButton,
    ValidationObserver,
    ValidationProvider,
    UploadDocument
  },
  props: {
    openModalPayment: {
      type: Boolean,
      defalut: false
    },
    applicantid: {
      type: Number,
      default: 0
    },
    sentMemberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      iconDownload: require('@/assets/image/iconDownload.png'),
      iconErrorPayment: require('@/assets/image/errorPayment.png'),
      iconWarning: require('@/assets/image/warning.png'),
      bath: '',
      dataPayment: {
        refferalCode1: '',
        refferalCode2: '',
        qrcodeText: '',
        qrcodeUrl: '',
        slipfile: '',
        paid_date: '',
        paid_time: '',
        bankname: '',
        amount: '',
        due_date: '',
        transaction_id: ''
      },

      bank: [
        { label: 'ธนาคารกรุงไทย จำกัด (มหาชน) ', value: 'KTB' },
        { label: 'ธนาคารกสิกรไทย จำกัด (มหาชน)', value: 'KBANK' },
        { label: 'ธนาคารเกียรตินาคิน (มหาชน)', value: 'KK' },
        { label: 'ธนาคารทิสโก้ จำกัด (มหาชน) ', value: 'TISCO' },
        { label: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)', value: 'TTB' },
        {
          label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร จำกัด (มหาชน)',
          value: 'BAAC'
        },

        { label: 'ธนาคารกรุงเทพ จำกัด (มหาชน)', value: 'BBL' },
        { label: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน) ', value: 'SCB' },
        { label: 'ธนาคารออมสิน จำกัด (มหาชน)', value: 'GSB' },
        { label: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)', value: 'BAY' },
        { label: 'ธนาคารซิตี้แบงก์ ', value: 'CITY' },

        { label: 'ธนาคารซีไอเอ็มบีไทย จำกัด', value: 'CIMBT' },
        { label: 'ธนาคารยูโอบี จำกัด (มหาชน) ', value: 'UOB' },
        { label: 'ธนาคารมิซูโฮจำกัด จำกัด (มหาชน)', value: 'Mizuho' },
        { label: 'ธนาคารไอซีบีซี', value: 'ICBC' }
      ],
      pollingInterval: null,
      hasShownPopup: false
    }
  },
  mounted() {
    this.getDataPayment()
  },
  computed: {
    allform() {
      var result = this.formdata.formitems
      if (result) {
        if (result.some(el => el.questiontype == 'หน้าถัดไป')) {
          var data = []
          var count = 0
          // eslint-disable-next-line no-continue
          result.map((el, index) => {
            if (el.questiontype == 'หน้าถัดไป') {
              count += 1
            } else {
              // eslint-disable-next-line no-continue4
              if (data[count]) {
                data[count].push(el)
              } else {
                data.push([el])
              }
            }
          })
          this.totalPage = data.length
          return data[this.currentPage]
        } else {
          return result
        }
      }
    },
    corditiondp() {
      if (this.projectdata != null) {
        if (!this.foruser.includes('DP') && !this.foruser.includes('Non-DP')) {
          return true
        }
        if (
          // this.currentStepIndex == 0 &&
          this.memberData.dptype &&
          this.foruser.includes(this.memberData.dptype)
        ) {
          return true
          // } else if (this.currentStepIndex > 0) {
          //     return true;
        } else {
          return false
        }
      } else {
        return false
      }
    },
    corditiondate() {
      if (this.project && this.project.showstartdate && this.project.showenddate) {
        let start = this.project.showstartdate
        let end = this.project.showenddate
        let curr = new Date()
        start = new Date(start)
        end = new Date(end)
        curr.setHours(0, 0, 0, 0)
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)
        if (curr >= start && curr <= end) {
          // console.log("formdata: ", this.formdata.button);
          this.formButton = this.formdata.button
          this.formReject = this.formdata.reject

          // thiButon = this.formdata[0].button
          return true
        } else {
          return false
        }
      } else {
        return null
      }
    },
    foruser() {
      return this.project && this.project.foruser ? this.project.foruser.split(',') : []
    },

    dbdData() {
      console.log('this.dbd ', this.dbd)
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0]
        ? this.dbd.data.data.ResultList[0]
        : null
    },
    RegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        this.dbd.data.data.ResultList[0].RegisterCapital
        ? this.dbd.data.data.ResultList[0].RegisterCapital
        : null
    },
    PaidRegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        this.dbd.data.data.ResultList[0].PaidRegisterCapital
        ? this.dbd.data.data.ResultList[0].PaidRegisterCapital
        : null
    }
  },
  methods: {
    showModalPayment() {
      this.$emit('close')
      location.reload()
    },
    async startPolling() {
      console.log('startPolling: ', startPolling)
      this.hasShownPopup = false
      this.pollingInterval = setInterval(async () => {
        try {
          console.log('try to check payment checkPaymentStatus')
          await this.checkPaymentStatus()
        } catch (error) {
          console.error('Error checking status:', error)
        }
      }, 5000)
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
        this.pollingInterval = null
      }
    },
    // startPolling() {
    //   this.pollingInterval = setInterval(this.checkPaymentStatus, 5000);
    // },
    // stopPolling() {
    //   clearInterval(this.pollingInterval);
    // },
    downloadQRCode() {
      const url = this.dataPayment.qrcodeUrl
      const link = document.createElement('a')
      link.href = url

      link.download = `depaQRcode-${this.dataPayment.refferalCode1}.png`
      link.click()
    },
    async checkPaymentStatus() {
      console.log('hello From: checkPaymentStatus')
      let checkdata = {
        ref1: this.dataPayment.refferalCode1,
        ref2: this.dataPayment.refferalCode2
      }
      const data = await api.getPaymentStatus(checkdata)
      if (data.responsecode == 200 && !this.hasShownPopup) {
        this.hasShownPopup = true
        this.stopPolling()
        this.$swal
          .fire({
            title: 'ชำระเงินสำเร็จ',
            icon: 'success',
            confirmButtonText: 'ตกลง'
          })
          .then(() => {
            this.sendPaymenttOdoo(
              data.data[0].name,
              data.data[0].institute_name,
              data.data[0].id_card,
              data.data[0].amount,
              data.data[0].memberid
            )
          })
      } else {
        this.startPolling()
      }
    },
    async sendPaymenttOdoo(name, institute_name, id_card, price, memberid) {
      if (!name) {
        name = institute_name
      }
      let data = {
        name: name,
        tax: id_card,
        price: price,
        memberid: memberid
      }

      const res = await api.sendodoo(data)
      if (res.responsecode == 201) {
        return res.message
      }
    },

    async getDataPayment() {
      console.log('applicantid: ', this.applicantid)

      const { data } = await api.depaProjectPayment(this.sentMemberId, this.applicantid)
      // console.log("data", data)
      this.dataPayment = {
        refferalCode1: data.data[0].qrcode_data.ref1,
        refferalCode2: data.data[0].qrcode_data.ref2,
        qrcodeText: data.data[0].qrcode_text,
        due_date: moment(data.data[0].duedate).format('DD/MM/YYYY'),
        transaction_id: data.data[0].transaction_id
      }
      console.log('fontData: ', this.dataPayment)
      this.bath = data.data[0].amount
      this.generateQRCode()
    },

    async postUpdateSlip() {
      console.log('postUpdateSlip')
      if (await this.$refs.form.validate()) {
        const sendData = {
          slipfile: this.dataPayment.slipfile[0],
          // paid_date: moment(this.dataPayment.paid_date, "DD/MM/YYYY").format(
          //   "YYYY-MM-DD"
          // ),
          // paid_time: this.dataPayment.paid_time,
          // bankname: this.dataPayment.bankname,
          transaction_id: this.dataPayment.transaction_id
        }
        console.log('data save: ', sendData)
        const { data } = await api.updateSlip(sendData)
        if (data.data.responsecode == 200) {
          this.$swal
            .fire({
              type: 'success',
              title: 'ชำระเงินสำเร็จ',
              html: `
              แอดมินกำลังดำเนินการตรวจสอบรายการของท่าน
              <br>
              <span style="color: orange; margin-top: 10px">
                <span style="display: inline-block; width: 7px; height: 7px; background-color: orange; margin-right: 5px; border-radius: 10px; margin-bottom: 1px"></span>
                รอการตรวจสอบ
              </span>
            `,
              icon: 'success',
              confirmButtonText: '<span style="padding: 15px" >ปิด</span>'
            })
            .then(result => {
              if (result.value == true) {
                this.openModalPayment = false
                this.$emit('close')
                location.reload()
              }
            })
          // this.openModalPayment = false
          // this.$emit('close')
          // location.reload()
        } else {
          this.openModalPayment = false
          this.$swal
            .fire({
              type: 'error',
              title: 'ชำระเงินไม่สำเร็จ',
              html: `
              กรุณาตรวจสอบข้อมูลอีกครั้ง
            `,
              icon: 'error',
              confirmButtonText: 'ลองอีกครั้ง'
            })
            .then(result => {
              if (result.isConfirmed) {
                this.openModalPayment = true
              }
            })
        }
      }
    },

    async postDownloadSlip(transactionId) {
      const { data } = await api.downloadSlip(transactionId)
      const href = URL.createObjectURL(data)
      // create "a" HTML element with href to file & click
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'payment.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    },

    goTo(path) {
      this.$router.push(`/${path}`)
    },

    async generateQRCode() {
      await QRCode.toDataURL(this.dataPayment.qrcodeText, (err, url) => {
        // console.log("QRCODE", url)
        if (err) {
          console.error(err)
          return
        }
        this.dataPayment.qrcodeUrl = url
      })
    },

    async uploadImg(data) {
      // console.log("uploadImg :", data);
      let uploaddata = {}
      // console.log("dataPayment", this.dataPayment)
    }
  }
}
</script>
<style lang="scss" scoped>
.multiselect__tag-icon:after {
  color: #80beff !important;
}

.multiselect__tag {
  background: #0e3154 !important;
}

.has-error .multiselect .multiselect__tags {
  border: 1px solid #ff3737 !important;
}

.uploaddepa {
  padding-right: 30px !important;
}

.v-input__slot {
  background-color: transparent !important;
}

.v-label {
  z-index: 20;
}

label.unit-text,
.unit-text input {
  position: relative;
  display: block;
  padding-right: 40px !important;
  width: 260px;
  box-sizing: border-box;
}

label.unit-text::after {
  content: attr(data-unit);
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 16px;
  display: block;
  color: #bdbdbd;
  font-weight: bold;
}

.typeCard {
  border-radius: 6px;

  .typeCardHeader {
    background: #beccdb;
    border-radius: 6px 6px 0px 0px;
    height: 66px;
    color: #0c2f53;
    display: flex;
    align-items: center;
    padding: 0 24px;

    .headerNumber {
      display: flex;
      width: 26px;
      height: 26px;
      justify-content: center;
      align-items: center;
      background: transparent;
      border-radius: 50%;
      border: 2px solid #0c2f53;
    }

    .headerNumber + .headerText {
      margin-left: 14px;
    }
  }

  .typeCardBody {
    border: 1px solid #beccdb;
    border-radius: 0px 0px 6px 6px;

    .typeCardStep {
      margin: 20px 14px 20px 14px;
      padding: 20px;
      border: 1px solid #beccdb;
      border-radius: 6px;
    }
  }
}

.customCancelBtn {
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}

.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}

.dataReq {
  display: flex;
}

.dataReq::after {
  content: '*';
  color: red;
}

.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 16px;
}

// .error-warning {
//   background-position: left;
//   background-image: url('assets/image/warning.png');
//   background-size: 17px 17px;
//   padding-left: 20px;
//   font-size: 14px;
//   font-weight: 500;
//   color: red !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/AddMemberForm/PaymentModalProject.vue